module.exports = __webpack_public_path__ + "static/media/tools-all-clear.99e5fee9.svg";